<template>
    <div class="teamStatsSmall">
        <div class="statsCardLabel mb-4">
            <p class="stats-card-header">{{ translations.season }}</p>
            <div class="selectDiv">
                <select v-model="currentSeason" style="width: 100%; border-radius: 10px; padding: 8px 16px; border: 1px solid rgba(51, 51, 51, 0.25);">
                    <option v-for="(season) in goalStats.seasons.teamStatistics" :value="season.id">
                        20{{ season.season.seasonYear.split("/")[0] }}/20{{ season.season.seasonYear.split("/")[1] }}
                    </option>
                </select>
            </div>
        </div>
        <div class="d-flex justify-content-between flex-wrap flex-lg-nowrap">
            <div class="statsCard d-flex justify-content-between mr-md-4">
                <div class="stats-card-header">{{ translations.conceded }}</div><div class="stats-card-header" :key="conceded">{{ conceded }}</div>
            </div>
            <div class="statsCard d-flex justify-content-between mr-lg-4">
                <div class="stats-card-header">{{ translations.scored }}</div><div class="stats-card-header" :key="scored">{{ scored }}</div>
            </div>
            <div class="statsCard d-flex justify-content-between mr-md-4">
                <div class="stats-card-header">{{ translations.conceded_game }}</div><div class="stats-card-header" :key="concededGame">{{ concededGame }}</div>
            </div>
            <div class="statsCard d-flex justify-content-between">
                <div class="stats-card-header">{{ translations.scored_game }}</div><div class="stats-card-header" :key="scoredGame">{{ scoredGame }}</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'goal-stats',
    props: {
        goalStats: {
            type: Object,
            required: true,
        }, 
        translations: {
            type: Object,
            required: true,
        },

    },
    data: function () {
        return {
            currentSeason: this.goalStats.seasons.currentSeason.id,
        }
       
    },

    computed: {
        conceded() {
            return this.goalStats.seasons.teamStatistics[this.currentSeason].goals_conceded.value
        },
        scored() {
            return this.goalStats.seasons.teamStatistics[this.currentSeason].goals_scored.value
        },
        concededGame() {
            return +(this.goalStats.seasons.teamStatistics[this.currentSeason].goals_conceded.value/this.goalStats.seasons.teamStatistics[this.currentSeason].standings.gamesPlayed).toFixed(2)
        },
        scoredGame() {
            return +(this.goalStats.seasons.teamStatistics[this.currentSeason].goals_scored.value/this.goalStats.seasons.teamStatistics[this.currentSeason].standings.gamesPlayed).toFixed(2)
        }
    },
    
    mounted: function () {

        console.log(this.goalStats)
        // console.log(this.playerStats)
        // console.log(this.translations)
    },
}

</script>